import React from 'react';
import { LinearProgress, makeStyles } from '~/lib/bn-material-ui';
import { UnmonitoredBinIcon, useSirenEntity } from '~/utility/BinSentry-ui-utility';
import { BinLevelFillStripes, BinLevelFillSolids } from './bin-unmonitored-fill';
import classnames from 'classnames';
import useBinLevelStyles from './bin-level-styles';
import { useLatestBinLevel } from './use-bin-level';

const useStyles = makeStyles((theme) => {
  return {
    standAlone: {
      boxShadow: '0px 4px 4px 0px #00000040',
      border: `2px solid ${theme.palette.gray[50]}`,
      borderRadius: '4px',
      marginBottom: '1em',
    },
  };
});

export default function BinLevelUnmonitored({ href, volumes = [], standAlone, className, height, width }) {
  const binLevelStyles = useBinLevelStyles();
  const styles = useStyles();
  const { entity: bin } = useSirenEntity({ href: href });
  const { volume, loading } = useLatestBinLevel({ binId: href });

  if (!bin || loading) {
    return <LinearProgress />;
  }

  return (
    <div className={binLevelStyles.box} style={{
      ...height !== undefined ? { height } : {},
      ...width !== undefined ? { width } : {},
    }}>
      <div className={classnames(
        binLevelStyles.barContainer,
        {
          [styles.standAlone]: standAlone,
          [binLevelStyles.solid]: volumes.length,
          [binLevelStyles.stripes]: !volumes.length,
        },
        className,
      )}
      >
        {volumes.length ? (
          <BinLevelFillSolids
            volumes={volumes}
            totalVolume={bin.properties.volumes.fullTotal}
          />
        ) : (
          <BinLevelFillStripes
            volume={volume}
            totalVolume={bin.properties.volumes.fullTotal}
          />
        )}
        <UnmonitoredBinIcon className={binLevelStyles.icon} />
      </div>
    </div>
  );
}
